module.exports = __webpack_public_path__ + "img/PBSDLogo-min.c1387f81.png";